import { useEffect, useState } from "react";
import axios from "axios";
import { useSelector } from "react-redux";

export default function useAccountBalance(currencyOverride) {
    const {
        business,
        currency: currentCurrency,
        businessSwitching,
        wallets,
    } = useSelector((s) => s);
    const currency = currencyOverride || currentCurrency;
    const hasSelectedWallet = (wallets || []).some(
        (wallet) =>
            String(wallet?.currency || "").toUpperCase() ===
            String(currency || "").toUpperCase()
    );

    const [balance, setBalance] = useState(0);
    const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [details, setDetails] = useState(null)

    useEffect(() => {
        if (businessSwitching || !business?._id || !currency || !hasSelectedWallet) return;

        let cancelled = false;
        const controller = new AbortController();
        (async () => {
            setLoading(true);
            setError(null);
            try {
                const res = await axios.get(`/v1/wallets/account?currency=${currency}`, {
                    headers: { "x-business-id": business._id },
                    signal: controller.signal,
                });
                const acct = res?.data?.data ?? res?.data ?? {};
              if (!cancelled) {
                setBalance(acct?.balance ?? 0);
                setDetails(acct)
              };

            } catch (e) {
                if (!cancelled) {
                    setError(e);
                    setBalance(0);
                    console.error("Failed to fetch account balance:", e);
                }
            } finally {
                if (!cancelled) setLoading(false);
            }
        })();

        return () => {
            cancelled = true;
            controller.abort();
        };
    }, [business?._id, businessSwitching, currency, hasSelectedWallet]);

  return { balance, loading, error, currency, details };
}
